import { useContext } from 'react';
import { Block } from 'baseui/block';
import { Card, StyledBody } from 'baseui/card';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { KIND, Tag, VARIANT } from 'baseui/tag';
import { HeadingMedium, HeadingSmall, LabelMedium, ParagraphSmall } from 'baseui/typography';
import { faCheck, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MarginProgressBar } from 'libs/platform-apps/src/components/MarginProgress';
import { COLOURS, MARGIN_SEGMENTS, MARGIN_TARGETS, convertCurrencySymbolToCode, formatPrice, getDesiredCost } from '@gtintel/platform-utils';
import { ProjectContext, RequestEditorContext } from '../../context';
import { calculateTotalCost } from '../utils';
export const MarginTargets = ({
  projectMargin
}) => {
  const {
    fee,
    status
  } = useContext(RequestEditorContext);
  const {
    netPrice,
    currency,
    assignmentCosts
  } = useContext(ProjectContext);
  const currencyCode = convertCurrencySymbolToCode(currency());
  const totalCost = calculateTotalCost(status(), assignmentCosts(), +fee());
  return <div>
      <Block marginBottom="scale800">
        <Block display="flex" alignItems="center" justifyContent="space-between" marginBottom="scale300">
          <HeadingMedium margin="0">Current Gross Margin</HeadingMedium>
          <Tag closeable={false} kind={projectMargin >= MARGIN_TARGETS[0] ? KIND.positive : KIND.negative} variant={VARIANT.solid}>
            {projectMargin >= MARGIN_TARGETS[2] ? 'ICP ✅' : projectMargin >= MARGIN_TARGETS[1] ? 'Advisory 📈' : projectMargin >= MARGIN_TARGETS[0] ? 'CBI 📈' : 'Below minimum'}
          </Tag>
        </Block>

        <MarginProgressBar projectMargin={projectMargin} />
      </Block>

      <FlexGrid flexGridColumnCount={3} flexGridColumnGap="scale400" marginBottom="scale800">
        {MARGIN_TARGETS.map((target, index) => {
        const costForTarget = getDesiredCost(+netPrice(), target) - +assignmentCosts();
        const isHitting = projectMargin >= target;
        return <FlexGridItem key={index}>
              <Card overrides={{
            Root: {
              style: {
                borderLeftWidth: '4px',
                borderLeftStyle: 'solid',
                borderLeftColor: isHitting ? COLOURS.darkGreen : COLOURS.red,
                backgroundColor: isHitting ? COLOURS.lightGreen : COLOURS.white
              }
            }
          }}>
                <StyledBody>
                  <Block display="flex" alignItems="center" marginBottom="scale300">
                    <HeadingSmall margin="0" marginRight="scale300">
                      {MARGIN_SEGMENTS[index]}
                    </HeadingSmall>
                    <Tag closeable={false}>{(target * 100).toFixed(0)}%</Tag>
                    {isHitting && <FontAwesomeIcon icon={faCheck} color={COLOURS.green} size="lg" />}
                  </Block>

                  <Block>
                    <LabelMedium>Max Cost:</LabelMedium>
                    <HeadingSmall margin="0" color={isHitting || totalCost <= costForTarget ? COLOURS.black : COLOURS.red}>
                      {formatPrice(costForTarget, currencyCode)}
                    </HeadingSmall>

                    {!isHitting && <Block display="flex" alignItems="center" marginTop="scale300">
                        <FontAwesomeIcon icon={faWarning} color={COLOURS.orange} size="lg" />
                        <ParagraphSmall margin="0" marginLeft="scale100" color={COLOURS.orange}>
                          Need to reduce fee by{' '}
                          {formatPrice(fee() - costForTarget, currencyCode)}
                        </ParagraphSmall>
                      </Block>}
                  </Block>
                </StyledBody>
              </Card>
            </FlexGridItem>;
      })}
      </FlexGrid>
    </div>;
};